
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.287 9.372c.106-.172.219-.339.337-.5a.933.933 0 01.76-.372h9.233c.297 0 .583.13.759.371.118.162.23.33.337.501l1.08-1.08a1 1 0 111.414 1.415l-1.5 1.5a1.014 1.014 0 01-.114.098c.17.542.289 1.11.353 1.695H21a1 1 0 110 2h-2.055a8.955 8.955 0 01-.355 1.693 1 1 0 01.117.1l1.5 1.5a1 1 0 01-1.414 1.414l-1.082-1.082c-.964 1.561-2.41 2.729-4.137 3.176-.298.077-.574-.16-.574-.467v-9.25c0-.599-.448-1.084-1-1.084s-1 .485-1 1.083v9.251c0 .308-.276.544-.574.467-1.726-.447-3.173-1.615-4.137-3.176l-1.082 1.082a1 1 0 01-1.414-1.414l1.5-1.5c.037-.037.076-.07.117-.1A8.957 8.957 0 015.055 15H3a1 1 0 110-2h2.054a8.94 8.94 0 01.353-1.695 1.011 1.011 0 01-.114-.098l-1.5-1.5a1 1 0 011.414-1.414l1.08 1.08zM8.597 6.5c-.3 0-.536-.265-.456-.555.127-.466.336-.898.61-1.28l-.958-.958a1 1 0 011.414-1.414l1.088 1.088A3.985 3.985 0 0112 3c.61 0 1.188.137 1.705.38l1.088-1.087a1 1 0 111.414 1.414l-.958.959c.274.381.483.813.61 1.279.08.29-.155.555-.456.555H8.597z"}})])
          )
        }
      }
    